import * as actionType from "./ActionTypes";
import { findIndex } from "lodash";

export default function ContainerMasterEmailReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.CONTAINERMASTER_EMAIL_DATA:
      return (state = payload);
    case actionType.UPDATE_CONTAINERMASTER_EMAIL_DATA_TRACTOR:
      for (let i = 0; i < payload.data.length; i++) {
        const findId = findIndex(state, (data) => {
          return (
            data.ContainerMasterId ===
            parseInt(payload.data[i].ContainerMasterId)
          );
        });
        state[findId] = {
          ...payload.data[i],
          isEmailSentTractor: payload.isEmailSentTractor === 1 ? 1 : 0,
        };
      }
      return state;
    case actionType.UPDATE_CONTAINERMASTER_EMAIL_DATA_AGGREGATE:
      for (let i = 0; i < payload.data.length; i++) {
        const findId = findIndex(state, (data) => {
          return (
            data.ContainerMasterId ===
            parseInt(payload.data[i].ContainerMasterId)
          );
        });
        state[findId] = {
          ...payload.data[i],
          isEmailSentAggregate: payload.isEmailSentAggregate === 1 ? 1 : 0,
        };
      }
      return state;
    case actionType.UPDATE_CONTAINERMASTER_EMAIL_DATA_5M:
      for (let i = 0; i < payload.data.length; i++) {
        const findId = findIndex(state, (data) => {
          return (
            data.ContainerMasterId ===
            parseInt(payload.data[i].ContainerMasterId)
          );
        });
        state[findId] = {
          ...payload.data[i],
          isEmailSent5M: payload.isEmailSent5M === 1 ? 1 : 0,
        };
      }
      return state;
    default:
      return state;
  }
}
